import React from 'react';
import FormInputs from './FormInputs';
import Image from '../../../atoms/Image';
import WithBackgroundImage from '../../../darkmatter/WithBackgroundImage/WithBackgroundImage';
import closebtnImg from '../assets/closebtn.png';
import closebtnDarkImg from '../assets/closebtnDark.png';

const Form = props => {
  const { closeEmailCapture, type, image, darkCloseBtn } = props;
  const displayCloseBtn = type !== 'inline';

  if (image && image.url) {
    if (image.placement === 'background') {
      return (
        <WithBackgroundImage image={image.url}>
          <FormInputs {...props} />
        </WithBackgroundImage>
      );
    }
    if (image.placement === 'left') {
      return (
        <div className="emailcapture-withimage-horizontal">
          <WithBackgroundImage image={image.url}>
            <div />
          </WithBackgroundImage>
          <FormInputs {...props} />
        </div>
      );
    }
    if (image.placement === 'right') {
      return (
        <div className="emailcapture-withimage-horizontal">
          <FormInputs {...props} />
          <WithBackgroundImage image={image.url}>
            <div>
              {displayCloseBtn && (
                <Image
                  as="a"
                  id="closeEmailCapture"
                  src={darkCloseBtn ? closebtnDarkImg : closebtnImg}
                  onClick={() => closeEmailCapture(true)}
                />
              )}
            </div>
          </WithBackgroundImage>
        </div>
      );
    }
    if (image.placement === 'top') {
      return (
        <div className="emailcapture-withimage-vertical">
          <WithBackgroundImage image={image.url}>
            <div>
              {displayCloseBtn && (
                <Image
                  as="a"
                  id="closeEmailCapture"
                  src={darkCloseBtn ? closebtnDarkImg : closebtnImg}
                  onClick={() => closeEmailCapture(true)}
                />
              )}
            </div>
          </WithBackgroundImage>
          <FormInputs {...props} />
        </div>
      );
    }
  }

  return <FormInputs {...props} />;
};

export default Form;
